const JSZip = require('jszip');
const Alerts = require('lib/alerts');
const tpl = require('employer/templates/governmentForms/EaFormsMultiple.ejs');
const downloadjs = require('downloadjs');
const loader = require('helpers/loader');
const tooltip    = require('helpers/tooltip');
const moment = require('moment');
const axios = require('axios');
const log = require('lib/log')('employer/form-ea-multidownload');

const Promise = require('bluebird');

module.exports = Backbone.View.extend({
    itemViews: null,
    employeeIds: [],

    events: {
        'change .employee-all[type="checkbox"]': 'selectAllEmployee',
        'change .employee[type="checkbox"]': 'selectEmployee',
        'change #year': 'selectYear',
        'click .download-ea': 'downloadEa',
        'click .send-ea': 'sendEa'
    },

    initialize: function(options) {
        this.itemViews = [];
        this.employeeIds = [];
        this.collapsed = true;

        this.options = _.defaults(options || {}, {
            actionMode: 'download',
            year: moment().year()
        });

        this.collection.forEach(employee => {
            this.employeeIds.push(employee.id);
        });
    },

    render: function() {
        this.$el.html(tpl({
            model:      this.model,
            collection: this.collection,
            startYear: moment(app.company.get('createdAt')).year(),
            selectedYear: this.options.year,
            actionMode: this.options.actionMode
        }));

        tooltip.initBody();

        return this;
    },

    selectYear: function() {
        const year = parseInt(this.$('#year').val() || 2025, 10);
        this.options.year = year;
        return app.company.fetchFormEAEmployees(year)
            .then(employees => {
                this.collection = employees;
                this.employeeIds = employees.map(employee => employee.id);
                this.$('.employee-all[type="checkbox"]')
                    .prop('checked', true);
                this.render();
            });
    },

    selectEmployee: function(e) {
        const input = this.$(e.currentTarget);
        const id = input.val();
        const checked = input.prop('checked');

        if (checked === false) {
            const index = this.employeeIds.indexOf(id);
            this.employeeIds.splice(index, 1);

            this.$('.employee-all[type="checkbox"]')
                .prop('checked', false);
        } else if (checked === true) {
            this.employeeIds.push(id);
        }
    },

    selectAllEmployee: function(e) {
        const input = this.$(e.currentTarget);
        const checked = input.prop('checked');

        if (checked === false) {
            this.employeeIds = [];
            this.$('.employee[type="checkbox"]')
                .prop('checked', false);
        } else if (checked === true) {
            this.employeeIds = this.collection.map(emp => emp.id);
            this.$('.employee[type="checkbox"]')
                .prop('checked', true);
        }
    },

    downloadEa: function(ev) {
        const $button     = this.$(ev.currentTarget);
        const stopLoader  = loader.startFullScreen($button);
        const year = parseInt(this.$('select#year').val(), 10);

        const zip = new JSZip();

        return Promise.each(
            this.collection.filter(
                emp => this.employeeIds.includes(emp.id)
            ),
            employee => employee.generateFormEA(year)
                .then(attachment => {
                    const fileName = attachment.get('name')
                        .replace(/[/]|[\\]/g, '-');
                    return axios.get(attachment.getUrl(), {
                        timeout: 60000,
                        responseType: 'blob'
                    })
                        .then(response => {
                            // check if there is file name duplication as it would overwrite the existing ones.
                            if (zip.file(fileName) !== null) {
                                const numOfDuplicates =
                                    zip.file(new RegExp(fileName)).length;
                                zip.file(
                                    fileName.replace(
                                        /^([^().]+).*.pdf$/,
                                        (_, p1) =>
                                            `${p1}(${numOfDuplicates}).pdf`
                                    ),
                                    response.data
                                );
                            } else {
                                zip.file(fileName, response.data);
                            }
                        })
                        .catch(error => {
                            log.error(
                                `Form EA generating failed for employee ${
                                    employee.get('fullName')
                                }`
                            );
                            log.error(error.error);
                        });
                })
        )
            .then(() => zip.generateAsync({type: 'blob'}))
            .then(content => {
                downloadjs(content, `ea-forms-${year}.zip`, 'application/zip');
                stopLoader();
            })
            .catch(err => {
                Alerts.show('criticalError', err);
                stopLoader();
            });
    },

    sendEa: function(ev) {
        const $button     = this.$(ev.currentTarget);
        const stopLoader  = loader.startFullScreen($button);
        const year = parseInt(this.$('select#year').val(), 10);

        const ccEmail = this.$('input#ccEmail').val();

        return app.company.sendFormEA(this.employeeIds, year, ccEmail)
            .then(() => {
                Alerts.show('success', {
                    title: '',
                    text: `The employees will receive their EA forms\
                        shortly provided that an email address was \
                        entered in their profile.`
                });
                stopLoader();
            })
            .catch(err => {
                Alerts.show('criticalError', err);
                stopLoader();
            });
    },

    remove: function() {
        this.undelegateEvents();
        this.itemViews.forEach(view => view.remove());
    }
});



// WEBPACK FOOTER //
// ./app/employer/views/governmentForms/EaFormsMultiple.js